import axios from 'axios'

export const state = {
    categoriasResponse: [],
    marcasResponse: [],
}

export const mutations = {
    SET_CATEGORIAS_RESPONSE(state, payload) {
        state.categoriasResponse = payload
    },
    SET_MARCAS_RESPONSE(state, payload) {
        state.marcasResponse = payload
    },
}

export const actions = {
    async listCategorias({ dispatch }) {
        await axios
            .get("categoria/v2")
            .then((response) => {
                dispatch('changeCategoriasResponse', response.data)
            })
            .catch(() => { });
    },

    changeCategoriasResponse({ commit }, payload) {
        commit('SET_CATEGORIAS_RESPONSE', payload)
    },
    changeMarcasResponse({ commit }, payload) {
        commit('SET_MARCAS_RESPONSE', payload)
    },

}
